import uniq from 'lodash-es/uniq';
import {
    ForumArchivedCampaignsFetchFailureAction,
    ForumArchivedCampaignsFetchRequestAction,
    ForumArchivedCampaignsFetchSuccessAction,
    FORUM_ARCHIVE_CAMPAIGNS_FETCH_FAILURE,
    FORUM_ARCHIVE_CAMPAIGNS_FETCH_REQUEST,
    FORUM_ARCHIVE_CAMPAIGNS_FETCH_SUCCESS,
} from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.actions';
import { initialArchivedCampaignsState } from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.constants';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface ArchivedCampaignsState {
    ids: number[];
    loadingState: LoadingState;
    errorMessage: string;
}

type ArchivedCampaignsReducerAction =
    ForumArchivedCampaignsFetchRequestAction
    | ForumArchivedCampaignsFetchSuccessAction
    | ForumArchivedCampaignsFetchFailureAction;

const archivedCampaignsReducer: Reducer<ArchivedCampaignsState> =
    (state: ArchivedCampaignsState = initialArchivedCampaignsState, action: ArchivedCampaignsReducerAction) => {
    switch (action.type) {
        case FORUM_ARCHIVE_CAMPAIGNS_FETCH_SUCCESS:
            return {
                ...state,
                ids: uniq(action.response.result.campaigns),
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        case FORUM_ARCHIVE_CAMPAIGNS_FETCH_REQUEST:
        case FORUM_ARCHIVE_CAMPAIGNS_FETCH_FAILURE:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        default:
            return state;
    }
};

export default archivedCampaignsReducer;
